/**
 * Load more button for transaction archive page.
 */
jQuery( $ => { // use jQuery code inside this to avoid "$ is not defined" error
	let currentPage,
		loadingText,
		seeMoreText;
	$( '.show-more-articles' ).on( 'click', function() {
		const buttonclass = $( this ).attr( 'class' );
		const button = $( this );
		button.attr( 'disabled', true );
		loadingText = button.data( 'loading' );
		seeMoreText = button.text();
		const { posts, ajaxurl, maxPage } = acLoadmoreParams; // eslint-disable-line no-undef
		if ( ! currentPage ) {
			currentPage = acLoadmoreParams.currentPage; // eslint-disable-line no-undef
		}
		const dataObject = {
			action: 'loadmore',
			query: posts,
			page: currentPage,
		};

		$.ajax( {
			url: ajaxurl,
			data: dataObject,
			type: 'POST',
			beforeSend: () => {
				button.text( loadingText ); // change the button text, you can also add a preloader image
			},
			success: result => {
				if ( result ) {
					if ( buttonclass.match( 'ac-loadmore-transactions' ) ) {
						$( '.archive-transactions' ).append( result );
						const itemCount = $( '.archive-transactions' ).children().length;
						const totalItemCount = $( '.total-count' ).html();
						const numberPercentage = ( itemCount / totalItemCount ) * 100;
						$( '.item-counter-bar' ).width( numberPercentage + '%' );
						$( '.current-count' ).html( itemCount );
					} else if ( buttonclass.match( 'ac-loadmore-services' ) ) {
						$( '.archive-services' ).append( result );
					}
					currentPage++;
					button.text( seeMoreText );
					if ( currentPage >= maxPage ) {
						button.remove();
					} // if last page, remove the button
				} else {
					button.remove(); // if no data, remove the button as well
				}
			},
			complete: () => {
				button.attr( 'disabled', false );
			},
		} );
	} );
} );
